<div>
  <app-base-report *ngIf="salesReportData"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="true"
                   [filterFields]="filterField"
                   [reportName]="'Advanced Sales Report'"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="salesReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [selectionActions]="selectionActions"
                   [hasSort]="true"
                   [hasCancelRequest]="true"
                   [rowActions]="rowActions"
                   (rowActionClicked)="rowActionClicked($event)"
                   [isClickable]="true"
                   [customSelectionRows]="selectableRows"
                   (cancelAdvancedSalesRequest)="cancelAdvancedSalesRequest($event)"
                   (selectionActionTrigger)="selectionActionsCB($event)"
                   (sortTrigger)="sortChange($event)"
                   [selectionModel]="selectionModel"
                   [serviceInstance]="advanced_salesService"></app-base-report>
</div>
